import { Box, Button, Image } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';

function AllGamesBanner() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  return (
    <Box
      width="100%"
      marginVertical="space-300"
      height={{
        mobile: 120,
        tablet: 280,
        desktop: 500,
      }}
      justifyContent="center"
      alignItems="center"
      position="relative"
      backgroundColor="iconPrimary"
    >
      <Image
        name="games.allGamesBanner"
        contentFit="cover"
        width="100%"
        height="100%"
        borderRadius="radius-400"
        position="absolute"
        top="space-0"
        bottom="space-0"
        left="space-0"
        right="space-0"
      />
      <Button
        locKey="seeAllGames"
        locNS="games"
        size="small"
        onPress={() => navigation.navigate('AllGamesScreen')}
        position="absolute"
        rightIcon="arrowForward"
        width="100%"
        maxWidth={320}
      />
    </Box>
  );
}

export default memo(AllGamesBanner);
